import { gql } from '@apollo/client';

export const CORE_EXPERT_FIELDS = gql`
  fragment CoreExpertFields on Expert {
    id
    firstName
    lastName
    description {
      languageId
      languageCode
      value
    }
    shortDescription {
      languageId
      languageCode
      value
    }
    disabled
    socialLinks {
      id
      socialMediaType {
        id
      }
      url
    }
    picture {
      id
      file {
        id
        processingStatus
      }
      imageFiles {
        id
        key
      }
    }
    signature {
      id
      file {
        id
        processingStatus
      }
      imageFiles {
        id
        key
      }
    }
    domains {
      id
      domain
      name
    }
    languages {
      code
    }
    courses {
      id
      name {
        languageId
        languageCode
        value
      }
    }
  }
`;
